import React from 'react';
import styled from '@emotion/styled';
import { Slider } from '@mui/material';
import { debounce } from 'lodash';
import { Text } from '../../common';

const SliderContainer = styled.div`
  margin: 20px 0;
  padding: 0 10px;
  position: relative;
`;

const SliderValue = styled.div`
  position: absolute;
  left: ${props => props.value}%;
  transform: translateX(-50%);
  top: -20px;
  font-size: 12px;
  color: #666;
`;

const SliderLabels = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
  font-size: 12px;
  color: #666;
`;

const CustomSlider = ({
  questionId,
  value,
  onValueChange,
  minValue = 0,
  maxValue = 100,
  leadingLabel = '0',
  trailingLabel = '100',
  questionText,
  questionDescription,
  isRequired,
  disabled = false
}) => {
  const debouncedOnValueChange = debounce(newValue => {
    onValueChange(questionId, newValue);
  }, 100);

  const percentage = ((value - minValue) / (maxValue - minValue)) * 100;

  return (
    <div>
      <Text as="div" fontWeight="bold" mb="0.5rem" fontSize="15px">
        {questionText}
        {isRequired === 1 && <span style={{ color: '#f44336' }}> *</span>}
      </Text>

      {questionDescription && (
        <Text as="div" mb="1rem" style={{ fontStyle: 'italic' }}>
          {questionDescription}
        </Text>
      )}

      <SliderContainer>
        <SliderValue value={percentage}>{value}</SliderValue>
        <Slider
          value={value}
          onChange={(_, newValue) => debouncedOnValueChange(newValue)}
          disabled={disabled}
          min={minValue}
          max={maxValue}
          step={1}
          sx={{
            color: '#9ebe21',
            height: 4,
            '& .MuiSlider-thumb': {
              width: 20,
              height: 20,
              backgroundColor: '#fff',
              border: '2px solid #9ebe21',
              '&:hover, &.Mui-focusVisible': {
                boxShadow: '0px 0px 0px 8px rgba(158, 190, 33, 0.16)'
              }
            },
            '& .MuiSlider-track': {
              border: 'none'
            },
            '& .MuiSlider-rail': {
              opacity: 0.5,
              backgroundColor: '#e0e0e0'
            }
          }}
        />
        <SliderLabels>
          <span>{leadingLabel}</span>
          <span>{trailingLabel}</span>
        </SliderLabels>
      </SliderContainer>
    </div>
  );
};

export default CustomSlider;
